import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M2 13L11.293 3.70697C11.6835 3.31659 12.3165 3.31659 12.707 3.70697L22 13H20V21C20 21.5523 19.5523 22 19 22H14V15H10V22H5C4.44772 22 4 21.5523 4 21V13H2Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "HomeAltFill"
);
